import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PromotionsService } from '../../promotions.service';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatOption } from '@angular/material/core';
import { Location } from '@angular/common'
import * as moment from 'moment';

@Component({
  selector: 'app-edit-promotions',
  templateUrl: './edit-promotions.component.html',
  styleUrls: ['./edit-promotions.component.scss']
})
export class EditPromotionsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  generatePromoForm: FormGroup;
  providers: any;
  promotionsCountries: any = [];
  promotionsCarriers: any;
  promotionscodeGroups: any = [];
  occassionId: number;
  promotionData: any;
  isGenerateSend: boolean = false;
  isSaveContinue: boolean = false;
  isSave: boolean = false;
  editStatus: boolean = false;
  selectedCarrier;
  selectedcountriesList: any;
  applicableCountries: any;
  countries: any;
  showDiscountError: boolean = false;

  //productControl = new FormControl();
  @ViewChild('allSelected') private allSelected: MatOption;
  @ViewChild('allCarrierSelected') private allCarrierSelected: MatOption;
  promotionDetails: any;
  //carrierControl =  new FormControl();
  selectedcodegroups: any;
  selectedCarriers: any;
  formData: any;

  constructor(private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private promotionsService: PromotionsService,
    private activeRoute: ActivatedRoute,
    private location: Location
  ) {
    super();
    //;
this.initiateForm();

    this.promotionDetails = this.router.getCurrentNavigation()?.extras ? this.router.getCurrentNavigation().extras.state : this.router.getCurrentNavigation()?.extras;


    //countr
    //  this.promotionsService.getCarrierCountries().subscribe(
    //   res => {
    //     let _countries: any = res;
    //     if (_countries.httpcode == 200) {
    //       this.Countries = _countries.data;
    //       //;
    //     }
    //   }
    // );


    //carriers
    /*this.promotionsService.getCarriers().subscribe(
      res => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.promotionsCarriers = _carriers.data;
         
        }
      }
    );*/

    //codeGroups
    this.promotionsService.getcodeGroups().subscribe(
      res => {
        let _codeGroups: any = res;
        if (_codeGroups.httpcode == 200) {
          if(this.promotionDetails && this.promotionDetails.country=="India"){
            this.promotionscodeGroups=["IMTU"]
          }else{
            this.promotionscodeGroups = _codeGroups.data;
          }
        }
      }
    );

  }


  ngOnInit(): void {
    super.ngOnInit();


    if (this.promotionDetails == null || this.promotionDetails == undefined) {
      this.router.navigate(['features/promotions/ocassion-rewards/festival-promo']);
      return;
    }
    this.occassionId = this.promotionDetails?.occassionId;
    this.promotionsCountries.push({ countryName: this.promotionDetails.country })
    this.generatePromoForm.get('country').setValue(this.promotionDetails.country);
    // this.occassionId = this.router.getCurrentNavigation()?.extras?.state?.occasionId;
    if (this.occassionId && this.occassionId) {
      this.promotionsService.getPromoCodeByOccasion(this.occassionId).subscribe(
        res => {
          if (res['httpcode'] == 200 && res['data'].length > 0) {
            this.fillPromoForm(res['data'][0]);
            this.promotionData = res['data'][0];
            if (this.promotionData.promocodeStatus == "Active" && this.promotionData.notificationStatus.trim() == "No") {
              this.editStatus = true;
            }
          }
        }
      )
    }

  }
  fillPromoForm(formData: any) {
    this.formData = formData;

    this.promotionsService.getCarrierNamesbycountrycodegroup(this.promotionDetails.country, formData.codeGroups).subscribe(
      res => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.promotionsCarriers = _carriers.data;



          this.generatePromoForm.get('promoCode').setValue(this.formData.promocodeNumber);
          this.selectedcodegroups = this.formData.codeGroups
          this.selectedCarriers = this.formData.carriers
          //this.productControl.setValue(this.selectedcodegroups);
          //this.carrierControl.setValue(this.selectedCarriers);

          this.generatePromoForm.get('product').setValue([...this.formData.codeGroups.map(item => item.trim())]);
          this.generatePromoForm.get('carrier').setValue([...this.formData.carriers.map(item => item.trim())]);
          this.generatePromoForm.get('country').setValue(this.formData.country);
          this.generatePromoForm.get('amount1').setValue(this.formData.applicableMinAmount);
          this.generatePromoForm.get('amount2').setValue(this.formData.applicableMaxAmount);
          this.generatePromoForm.get('fromDate').setValue(moment(this.formData.promocodeStartDateTime).format());
          this.generatePromoForm.get('toDate').setValue(moment(this.formData.promocodeEndDateTime).format());
          this.generatePromoForm.get('discount').setValue(this.formData.discountValueType);
          this.generatePromoForm.get('discountValue').setValue(this.formData.discountValue);
          this.generatePromoForm.get('redeemLimit').setValue(this.formData.redeemLimit);
          this.generatePromoForm.get('description').setValue(this.formData.description);

        }
      }
    );

  }


  initiateForm = () => {
    this.generatePromoForm = this.fb.group({
      promoCode: '',
      product: '',
      carrier: '',
      country: '',
      amount1: '',
      amount2: '',
      fromDate: '',
      toDate: '',
      discount: '',
      discountValue: '',
      redeemLimit: '',
      description: '',
    })

    this.f['discount'].valueChanges.subscribe(res => {
      if (res === '$') {
        this.f['discountValue'].setValidators([Validators.max(this.f['amount1'].value)])
        this.f['discountValue'].updateValueAndValidity();
      } else {
        this.f['discountValue'].clearValidators();
        this.f['discountValue'].setValidators([Validators.max(100)])
        this.f['discountValue'].updateValueAndValidity();
      }
    })
    this.f['discountValue'].valueChanges.subscribe(res => {
      // this.f['discountValue'].setValidators([Validators.max(this.f['amount1'].value)])
      if(this.f['discount'].value === '$' && this.f['discountValue'].value >= this.f['amount1'].value){
        this.f['discountValue'].setValidators([Validators.max(this.f['amount1'].value)])
       this.showDiscountError=true;
      }else{
        this.showDiscountError=false;
      }
    })
    this.f['amount1'].valueChanges.subscribe(res => {
      
      // this.f['amount1'].setValidators([Validators.max(this.f['amount2'].value)])
      if (this.f['discount'].value === '$') {
        this.f['discountValue'].setValidators([Validators.max(this.f['amount1'].value)])
        this.f['discount'].updateValueAndValidity();
        this.f['discountValue'].updateValueAndValidity();
      } else {
        this.f['discountValue'].clearValidators();
        this.f['discountValue'].setValidators([Validators.max(100)])
      }
    })
    
   
  }
  checkDiscountValidation(event){
    if( this.f['amount1'].value > this.f['amount2'].value){
      this.f['amount1'].setValidators([Validators.max(this.f['amount2'].value)])
      this.f['amount1'].updateValueAndValidity();
    }else if(this.f['amount2'].value < this.f['amount1'].value){
      this.f['amount2'].setValidators([Validators.min(this.f['amount1'].value)])
      this.f['amount2'].updateValueAndValidity();
    }else{
      this.f['amount1'].clearValidators();
      this.f['amount1'].updateValueAndValidity();
      this.f['amount2'].clearValidators();
      this.f['amount2'].updateValueAndValidity();
    }
  }


  get f() {
    return this.generatePromoForm.controls;
  }




  generateSend() {
    this.isGenerateSend = true;
  }

  saveContinue() {
    this.isSaveContinue = true;
  }

  save() {
    this.isSave = true;
  }

  onPromoCodeSubmit() {
    //;
    if (!this.generatePromoForm.valid) {
      return
    }

    let formData: any =
    {
      "applicableMinAmount": this.f['amount1'].value,
      "applicableMaxAmount": this.f['amount2'].value,
      "carriers": this.f['carrier']?.value.filter(x => x != 0),
      "codeGroups": this.f['product']?.value.filter(x => x != 0),
      "country": this.f['country'].value,
      "description": this.f['description'].value,
      "discountValue": this.f['discountValue'].value,
      "discountValueType": this.f['discount'].value,
      "occassionId": this.occassionId,
      "promocodeNumber": this.f['promoCode'].value,
      "redeemLimit": this.f['redeemLimit'].value,
      "promocodeStartDateTime": moment(this.f['fromDate'].value).format('MM-DD-YYYY'),
      "promocodeEndDateTime": moment(this.f['toDate'].value).format('MM-DD-YYYY'),
    }


    if (this.isSaveContinue) {
      formData['notificationStatus'] = 'No'

      if (this.promotionData?.promocodeId) { formData['promocodeId'] = this.promotionData.promocodeId; this.savePromo(formData) } else { this.sendPromotion(formData) }

    }
    if (this.isSave) {
      formData['promocodeId'] = this.promotionData.promocodeId;

      this.savePromo(formData)

    }
    if (this.isGenerateSend) {
      formData['notificationStatus'] = 'Yes';
      if (this.promotionData?.promocodeId) { formData['promocodeId'] = this.promotionData.promocodeId; this.savePromo(formData) } else { this.sendPromotion(formData) }
    }

  }
  sendPromotion(formData: any) {
    this.promotionsService.generateSendPromo(formData).subscribe(res => {

      if (res['httpcode'] == 200) {
        let promocode = formatDate['promocodeNumber']
        if (this.isGenerateSend) {
          this.router.navigate([`features/promotions/manage-promo/generate-success`], { state: { promocode: promocode } })
          return
        }
        if (this.isSaveContinue) {
          this.router.navigate([`features/promotions/ocassion-rewards/promo-history`])
          return
        }
      }
    });
  }
  savePromo(formData: any) {
    this.promotionsService.savePromo(formData).subscribe(res => {

      if (res['httpcode'] == 200) {
        let promocode = formData['promocodeNumber']
        if (this.isSave) {
          this.router.navigate([`features/promotions/ocassion-rewards/promo-history`])
          return
        }
        if (this.isGenerateSend) {
          this.router.navigate([`features/promotions/manage-promo/generate-success`], { state: { promocode: promocode } })
          return
        }
        if (this.isSaveContinue) {
          this.router.navigate([`features/promotions/ocassion-rewards/promo-history`])
          return
        }
      }
    });
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        //this.generatePromoForm.reset();
        this.router.navigate([`features/promotions/ocassion-rewards/festival-promo`])
      }
    });
    //window.location.reload();
  }

  getCountryNames(e) {
    let codegroup = e.value;
    if (codegroup == 'DMTU') {
      this.promotionsCountries = [];
      this.promotionsCountries.push({ 'countryName': 'United States' })
    }
    if (codegroup == 'IMTU') {
      //country
      this.promotionsService.getCarrierCountries().subscribe(
        res => {
          let _countries: any = res;
          if (_countries.httpcode == 200) {
            this.promotionsCountries = _countries.data;

          }
        }
      );
    }
    if (codegroup == 'Pin less') {
      this.promotionsCountries = [];
      this.promotionsCountries.push({ 'countryName': 'United States' })
    }

  }
  private _filter(value: string): string[] {
    const filterValue = value;

    return this.countries.filter(option => option.countryName == value)[0].countryCode;
  }

  getCarrierNames() {
    let codeGroups: any = this.generatePromoForm.get('product').value.filter(x => x != 0)
    this.promotionsService.getCarrierNamesbycountrycodegroup(this.promotionDetails.country, codeGroups).subscribe(
      res => {
        let _carriers: any = res;
        if (_carriers.httpcode == 200) {
          this.promotionsCarriers = _carriers.data;

        }
      }
    );
  }
  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.generatePromoForm.get('product').patchValue([...this.promotionscodeGroups.map(item => item), 0]);
      this.getCarrierNames()
    } else {
      this.generatePromoForm.get('product').patchValue([]);
      this.promotionsCarriers = [];
    }
  }
  tosslePerOne(all) {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      this.getCarrierNames()
      return false;
    }
    if (this.generatePromoForm.get('product').value.length == this.promotionscodeGroups.length)
      this.allSelected.select();
    this.getCarrierNames()
  }

  toggleAllCarrierSelect() {
    if (this.allCarrierSelected.selected) {
      this.generatePromoForm.get('carrier').patchValue([...this.promotionsCarriers.map(item => item), 0]);
    } else {
      this.generatePromoForm.get('carrier').patchValue([]);
    }

  }
  toggleCarrierSelect(all) {
    if (this.allCarrierSelected.selected) {
      this.allCarrierSelected.deselect();
      return false;
    }
    if (this.generatePromoForm.get('carrier').value.length == this.promotionsCarriers.length)
      this.allCarrierSelected.select();
  }

}
